<template>
  <div v-if="map" class="map-draw-tool" />
</template>

<script>
import L from 'leaflet';
import 'leaflet-draw';

export default {
  name: 'MapDraw',
  props: {
    map: { type: Object, required: true },
    enabled: { type: Boolean, default: true },
  },
  data() {
    return {
      drawControl: null,
      featureGroup: null,
    };
  },
  mounted() {
    if (this.enabled) this.initDrawing();
  },
  methods: {
    initDrawing() {
      this.featureGroup = new L.FeatureGroup();
      this.map.addLayer(this.featureGroup);

      this.drawControl = new L.Control.Draw({
        edit: {
          featureGroup: this.featureGroup,
        },
        draw: {
          polyline: false,
          rectangle: false,
          circle: false,
          circlemarker: false,
          marker: false,
          polygon: {
            allowIntersection: false,
            showArea: true,
          },
        },
      });

      this.map.addControl(this.drawControl);

      // Draw Create
      this.map.on(L.Draw.Event.CREATED, (e) => {
        const layer = e.layer;
        this.featureGroup.addLayer(layer);

        const geojson = layer.toGeoJSON();
        this.$emit('shape-drawn', geojson);
      });

      // Shape Edited
      this.map.on(L.Draw.Event.EDITED, () => {
        const all = this.featureGroup.toGeoJSON();
        this.$emit('shapes-updated', all);
      });

      // Shape Deleted
      this.map.on(L.Draw.Event.DELETED, () => {
        const all = this.featureGroup.toGeoJSON();
        this.$emit('shapes-updated', all);
      });
    },
  },
};
</script>
